import UnifiedGroupDetails from 'owa-service/lib/contract/UnifiedGroupDetails';
import { getGroupResourceUrl } from 'owa-groups-shared-store';

export default function getSharePointFileLocation(
    fileUrl: string,
    groupDetails: UnifiedGroupDetails
): string {
    if (
        fileUrl == null ||
        fileUrl.length == 0 ||
        groupDetails == null ||
        groupDetails.GroupResources == null
    ) {
        return '';
    }

    const sharePointDocumentLibrary = getGroupResourceUrl(groupDetails, 'Files') || '';

    return sharePointDocumentLibrary.length == 0
        ? fileUrl
        : groupDetails.DisplayName +
              truncateFileName(fileUrl.substr(sharePointDocumentLibrary.length));
}

function truncateFileName(fullPath: string): string {
    return fullPath.substr(0, fullPath.lastIndexOf('/'));
}
